import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { NotifBel } from '../components/PortalLayout';

const A = '#00D4AA';

const ONDERDELEN = [
  { recht: 'accounts:beheren', icon: '\ud83d\udc65', titel: "Collega's beheren", sub: 'Portaal-logins uitnodigen', path: '/beheer' },
  { recht: 'objecten:lezen', icon: '\ud83d\udcf7', titel: 'Scan object', sub: 'QR-code scannen', path: '/scan' },
  { recht: 'objecten:lezen', icon: '\ud83c\udfd7\ufe0f', titel: 'Mijn objecten', sub: 'Installaties en locaties', path: '/objecten' },
  { recht: 'onderhoud:lezen', icon: '\ud83d\udee0\ufe0f', titel: 'Onderhoudsplanning', sub: 'Geplande onderhoudsbeurten', path: '/onderhoud' },
  { recht: 'werkorders:lezen', icon: '\u2705', titel: 'Afgeronde werkorders', sub: 'Uitgevoerd werk', path: '/werkorders' },
  { recht: 'logboek:lezen', icon: '\ud83d\udcdd', titel: 'Logboek', sub: 'Werkzaamheden-historie', path: '/logboek' },
  { recht: 'storingen:lezen', icon: '\ud83d\udea8', titel: 'Mijn storingen', sub: 'Gemelde storingen', path: '/storingen' },
  { recht: 'storingen:melden', icon: '\ud83d\udce3', titel: 'Melding maken', sub: 'Storing of probleem doorgeven', path: '/melding' },
  { recht: 'datum:verzoeken', icon: '\ud83d\udcc5', titel: 'Datum aanvragen', sub: 'Andere onderhoudsdatum' },
  { recht: 'documenten:lezen', icon: '\ud83d\udcc4', titel: 'Documenten', sub: 'Werkbonnen downloaden' },
];

function Kaart({ o }) {
  return (
    <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12, padding: 16, boxShadow: '0 1px 3px rgba(0,0,0,0.04)', height: '100%', position: 'relative' }}>
      <div style={{ fontSize: 26 }}>{o.icon}</div>
      <div style={{ fontWeight: 600, color: '#1e293b', marginTop: 8, fontSize: 15 }}>{o.titel}</div>
      <div style={{ color: '#64748b', fontSize: 12, marginTop: 2 }}>{o.sub}</div>
      {!o.path && <div style={{ position: 'absolute', top: 12, right: 12, fontSize: 10, color: '#94a3b8', background: '#f1f5f9', padding: '2px 6px', borderRadius: 5 }}>binnenkort</div>}
    </div>
  );
}

export default function Dashboard() {
  const { info, logout } = useAuth();
  const rechten = info?.rechten || [];
  const beschikbaar = ONDERDELEN.filter((o) => rechten.includes(o.recht));
  return (
    <div style={{ minHeight: '100vh', background: '#f1f5f9' }}>
      <header style={{ background: '#0a0e1a', color: '#e2e8f0', padding: '16px 20px', paddingTop: 'calc(env(safe-area-inset-top, 0px) + 16px)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ fontSize: 16, fontWeight: 700 }}>WOM<span style={{ color: A }}>sys</span> Klantportaal</div>
          <div style={{ fontSize: 13, color: '#94a3b8' }}>{info?.naam || info?.bedrijf}</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <NotifBel />
        <button onClick={logout} style={{ background: 'transparent', border: '1px solid #1f2937', color: '#94a3b8', padding: '7px 12px', borderRadius: 8, fontSize: 13 }}>Uitloggen</button>
        </div>
      </header>
      <main style={{ padding: 20, maxWidth: 640, margin: '0 auto' }}>
        <p style={{ color: '#475569', fontSize: 14, marginTop: 0 }}>
          Welkom{info?.account ? ', ' + info.account : ''}. Hieronder ziet u de onderdelen waarvoor u toegang heeft.
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 12 }}>
          {beschikbaar.map((o) =>
            o.path ? (
              <Link key={o.recht} to={o.path} style={{ textDecoration: 'none' }}><Kaart o={o} /></Link>
            ) : (
              <div key={o.recht}><Kaart o={o} /></div>
            )
          )}
        </div>
        {beschikbaar.length === 0 && (
          <p style={{ color: '#64748b', textAlign: 'center', marginTop: 40 }}>Er zijn nog geen onderdelen voor u vrijgegeven.</p>
        )}
      </main>
    </div>
  );
}
